import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { AnchorLink } from "gatsby-plugin-anchor-links";
import { Link } from 'gatsby';



const MenuSection = styled.section`
    width:80%;
    max-width:100%;
    background-color:#f0fafe;
    display:block;
    padding-bottom:20px;

    @media (max-width:${props => props.theme.breakpoints.md}) {
        width:100%;
    }
    @media (min-width:${props => props.theme.breakpoints.sm}) { 
        display:inline-block;
    }
`;

const HideSpan = styled.span`
    margin-left:20px;
    margin-right:20px;
    display: none;
    @media (max-width:${props => props.theme.breakpoints.sm}) {
        display:block;
        border-bottom: 1px solid #caccd0;
    }
`;

const TitleBox = styled.div`
    padding:20px;
       h4 {
           margin-top:0;
           margin-bottom:20px;
       }
       h5 {
           color:red;
           text-decoration:underline;
       }
`;

const MenuItems = styled.div`
    @media (min-width:${props => props.theme.breakpoints.sm}) { 
        display: -webkit-flex;
        display: flex;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-align-items: stretch;
        align-items: stretch;
    }
    a {
        margin:0px;
        text-decoration:none;
        color:black;
    }
`;

const MenuContent = styled.div`

    padding:40px;

    @media (max-width:${props => props.theme.breakpoints.md}) {
        padding:0px;
        img {
            ${'' /* width: */}
            margin:0px;
        }
        h4 {
            margin:5px;
        }
    }
`;

const MenuText = styled.div`
`;

const MenuItem = styled.div`
    display:inherit;
`;

const TopMenuPc = ({ PartyIcon, CategoryIcon, HowtoIcon, MannerIcon, DetailIcon }) => (
    <MenuSection>
    <TitleBox>
        <HideSpan>
        <h3>喜乐</h3>
        <h3>喜乐欢迎光临</h3>
        </HideSpan>
    </TitleBox>
    <MenuItems>
    <MenuItem>
    <Link to="/food">
        <MenuContent>
            { PartyIcon }
        <MenuText>
            <h4>食物</h4>
            <p>食物一覧全体</p>
        </MenuText>
        </MenuContent>
    </Link>
    </MenuItem>
    <MenuItem>
    <AnchorLink to='/#category' title="カテゴリー">
        <MenuContent>
            { CategoryIcon }
        <MenuText>
            <h4>食物选择</h4>
            <p>可以选择口味类型</p>
        </MenuText>
        </MenuContent>
    </AnchorLink>
    </MenuItem>
    <MenuItem>
    <Link to="/quickstartGuide">
        <MenuContent>
            { HowtoIcon }
        <MenuText>
            <h4>利用方式</h4>
            <p>介绍怎么点单</p>
        </MenuText>
        </MenuContent>
    </Link>
    <Link to="/manner">
        <MenuContent>
            { MannerIcon }
        <MenuText>
            <h4>基本</h4>
            <p>关于基本的事情</p>
        </MenuText>
        </MenuContent>
    </Link>
    <Link to="/aboutxile">
        <MenuContent>
        { DetailIcon }
        <MenuText>
            <h4>喜乐<br />仔细说明</h4>
            <p>欢迎光临喜乐 我们介绍关于喜乐</p>
        </MenuText>
        </MenuContent>
    </Link>
    </MenuItem>    
    </MenuItems>
</MenuSection>
    )

export default TopMenuPc;

TopMenuPc.propTypes = {
    PartyIcon: PropTypes.element,
    CategoryIcon: PropTypes.element,
    HowtoIcon: PropTypes.element,
    MannerIcon: PropTypes.element,
    DetailIcon: PropTypes.element,
};